import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

interface BoardblendLoaderProps {
  compact?: boolean;
  label?: string;
}

export function BoardblendLoader({
  compact = false,
  label = "Loading",
}: BoardblendLoaderProps) {
  return (
    <span
      className={cn("boardblend-loader", compact && "boardblend-loader-compact")}
      role="status"
      aria-label={label}
    >
      {Array.from({ length: 25 }, (_, index) => (
        <i
          key={index}
          style={{
            "--column": index % 5,
            "--row": Math.floor(index / 5),
          } as CSSProperties}
        />
      ))}
    </span>
  );
}
